export default "__VITE_ASSET__D6y1peG4__"